import React from "react";
import NavBar from "../Components/Navbar";

const PrivacyPolicy = () => {
  return (
    <div className="container py-5">
      <h1>Privacy Notice</h1>
      <p>
        We encourage you to read this Privacy Policy in full to understand the
        types of information we collect, how we use it, and how we protect it.
      </p>

      <p>
        Thank you for visiting the American Yacht Group International website.
        We value your interest in our company and the flagship yachting services
        we offer. By using our website, you are accepting the terms outlined in
        this Privacy Policy and our Terms and Conditions. This Privacy Policy
        applies to all websites and digital services operated by American Yacht
        Group International.
      </p>

      <h2>What Information We Collect</h2>
      <p>
        We collect both personally identifiable and non-identifiable (anonymous)
        information when you:
      </p>
      <ul>
        <li>Subscribe to our mailing list.</li>
        <li>Inquire about or purchase a yacht!</li>
        <li>Request information on brokerage or charter services.</li>
        <li>Register for an event or boat show.</li>
        <li>Apply for a job or contact us for support.</li>
      </ul>

      <p>Information collected may include:</p>
      <ul>
        <li>First and Last Name</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>IP Address</li>
        <li>ISP information</li>
        <li>Date and time of your visit</li>
        <li>Page interactions and clickstream data</li>
      </ul>

      <p>
        We use this data to improve your browsing experience and tailor content
        and services based on user behavior, demographics, and preferences.
      </p>

      <h2>Rights Under GDPR and CCPA</h2>
      <h4>For EU Residents (GDPR):</h4>
      <ul>
        <li>The right to be informed</li>
        <li>The right of access</li>
        <li>The right to rectification</li>
        <li>The right to erasure</li>
        <li>The right to restrict processing</li>
        <li>The right to data portability</li>
        <li>The right to object</li>
        <li>Rights in relation to automated decision-making and profiling</li>
      </ul>

      <h4>For California Residents (CCPA):</h4>
      <ul>
        <li>
          The right to know what personal data we collect before it is collected
        </li>
        <li>The right to access the personal data we hold</li>
        <li>The right to opt in/out of marketing and analytics</li>
        <li>The right to request deletion of personal data</li>
        <li>The right to receive equal service without discrimination</li>
      </ul>

      <p>
        To exercise any of the above rights, please contact us at:{" "}
        <a href="mailto:privacy@americanyachtgroup.com">
          privacy@americanyachtgroup.com
        </a>
      </p>

      <h2>How We Use Your Information</h2>
      <ul>
        <li>To deliver and improve our yacht brokerage and related services</li>
        <li>
          To send updates about industry trends, new listings, events, and
          promotions
        </li>
        <li>To respond to your inquiries and service requests</li>
        <li>
          To analyze user behavior and interests to enhance website features
        </li>
        <li>
          To connect you with trusted affiliates (e.g., yacht financing,
          insurance, transportation)
        </li>
        <li>To detect and prevent malicious activity</li>
      </ul>
      <p>We do not sell your personal information to third parties.</p>

      <h2>Interest-Based Advertising (IBA)</h2>
      <p>
        American Yacht Group International participates in Interest-Based
        Advertising. We use cookies and similar technologies (such as pixel
        tags) to collect browsing activity across your devices to show you
        relevant advertisements on our site and other platforms.
      </p>

      <h2>Advertising Policy</h2>
      <p>
        We may allow select partners such as yacht OEMs, charter companies, or
        related marine advertisers to promote their offerings on certain parts
        of our website. These advertisers must adhere to our policies and legal
        standards. Any inappropriate content or violation of laws will not be
        tolerated.
      </p>

      <h2>Data Retention & Storage</h2>
      <p>We retain your data only for as long as it is needed to:</p>
      <ul>
        <li>Fulfill the service(s) you requested</li>
        <li>Meet legal and regulatory obligations</li>
        <li>Serve legitimate business purposes</li>
      </ul>
      <p>
        All information collected is stored securely and may be shared with
        government authorities if legally required. As a U.S.-based company,
        your data is stored and processed under U.S. authority.
      </p>

      <h2>Data Security</h2>
      <p>
        We take appropriate security measures to protect your data from
        unauthorized access, alteration, or disclosure during both transmission
        and storage. However, no method of data transmission over the internet
        or electronic storage is completely secure, and we cannot guarantee
        absolute security.
      </p>

      <h2>Use of Cookies</h2>
      <p>
        We use cookies and related technologies to personalize content, remember
        your preferences, and improve your experience on our website. Cookies
        help us identify repeat visitors and enhance your interaction with the
        site. For more details, please refer to our Cookie Policy.
      </p>

      <h2>AI Chat Assistance</h2>
      <p>
        If you interact with our AI chat support, your conversation data is not
        stored. All chat session data is automatically cleared when your session
        ends or the browser is closed.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        This Privacy Policy was last revised on April 17, 2025. We may update
        this policy periodically. Any significant changes will be communicated
        through notices on our website, email, or other appropriate means. We
        encourage you to check this page regularly for updates.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy or how we handle
        your personal data, please reach out to us at:{" "}
        <a href="mailto:martin@americanyachtgroupinternational.com">
          martin@americanyachtgroupinternational.com
        </a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
